
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue"
import CoursesContent from "./components/CoursesContent.vue";


export default defineComponent({
  name: "UsersPage",
  components: {
    BreadCrumb,
    CoursesContent
},
});
